import { makeActionCreator } from 'redux-toolbelt';

const linksAction = type => makeActionCreator(`LINKS/${type}`);
export const addLink = linksAction('ADD');
export const removeLink = linksAction('REMOVE');